import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { TanStackQueryIds } from '../../query/query-ids'
import { deleteTag } from '~~/src/api/tags'
import type { TagData } from '~~/src/api/tags'
import type { GetArg } from '~~/src/types/utils'

type FnType = typeof deleteTag
type Args = GetArg<typeof deleteTag>

export interface DeleteTagMutateArgs { tagId: Args[0]; userId?: MaybeRef<string | null | undefined>; elementalId: MaybeRef<string | null | undefined>}

export const useDeleteTagMutation = () => {
  const queryClient = useQueryClient()
  return useMutation<Awaited<ReturnType<FnType>>, Error, DeleteTagMutateArgs>({
    mutationKey: ['create-tag'],
    mutationFn: async ({ tagId }) => {
      return await deleteTag(tagId)
    },
    onMutate({ tagId, userId, elementalId }) {
      queryClient.setQueriesData<TagData[]>({
        queryKey: ['user-tags', userId],
        exact: false,
        type: 'all',
      }, (old) => {
        if (!old)
          return old
        return old.filter(tag => tag.id !== tagId)
      })
      if (elementalId) {
        queryClient.setQueriesData<TagData[]>({
          queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],

          exact: false,
          type: 'all',
        }, (old) => {
          if (!old)
            return old
          return old.filter(tag => tag.id !== tagId)
        })
      }
    },
    onError: (_, { userId, elementalId }) => {
      queryClient.refetchQueries({
        queryKey: ['user-tags', userId],
        exact: false,
        type: 'all',
      })
      if (elementalId) {
        queryClient.refetchQueries({
          queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],
          exact: false,
          type: 'all',
        })
      }
    },
    onSuccess: (result, { userId }) => {
      if (!result)
        return
      queryClient.invalidateQueries({
        queryKey: ['user-tags', userId],
        exact: false,
        type: 'all',
      })
    },
  })
}
